import React from 'react'
import { analytics } from '../../services'
import ConsentBox from '../../components/DesignSystem/ConsentBox'
import {
  Box,
  Card,
  CardHeader,
  Text,
  Button,
  Center,
  Link,
} from '@chakra-ui/react'
class consents extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showConfirmation: false,
      disabled: true,
      isLoading: false,
    }
  }
  singleUpdate() {
    if (this.props.currentStep === 5) {
      analytics.track('Consents', 'Wizard', { page: 5 })
      window.scrollTo(0, 0)
      //Allows for use on single DidUpdate
      this.singleUpdate = function () { }
    }
  }

  componentDidUpdate() {
    this.singleUpdate()
  }

  render() {
    if (this.props.currentStep !== 5) {
      return null
    }

    return (
      <Box bg="#EBF9FF">
        {' '}
        <Center>
          <Card mt={10} mb={10} maxW={'640px'} boxShadow="xl" p={10}>
            <CardHeader>
              <Text ml={-3} textStyle="t6" as="b" color="pb100">
                Review our consents
              </Text>
            </CardHeader>
            <ConsentBox
              consentTitle="Electronic Consents"
              isRequired
              onChange={this.props.onESignConsent}
              checkBoxLabel="I consent (required)"
            >
              {' '}
              <Text textStyle="b3">
                By checking this box, you confirm that you have reviewed the {' '}
                <Link
                  style={{
                    textDecoration: 'underline',
                    color: '#2171A6',
                  }}
                  isExternal
                  color="teal.500"
                  href="https://www.republicfinance.com/legal/esign-consent"
                >
                  Consent for Electronic Signatures and Records
                </Link>
                ,{' '}that you can view and retain the electronic records described in it; and you consent to receive electronic records and use electronic signatures as outlined in that disclosure. In addition, by checking this box, you confirm that you have received and read the Republic Finance {' '}
                <Link
                  style={{
                    textDecoration: 'underline',
                    color: '#2171A6',
                  }}
                  isExternal
                  color="teal.500"
                  href="https://www.republicfinance.com/legal/privacy-notice"
                >
                  Privacy Notice
                </Link>{' '}
                and (ii) read the {' '}
                <Link
                  style={{
                    textDecoration: 'underline',
                    color: '#2171A6',
                  }}
                  isExternal
                  color="teal.500"
                  href="https://www.republicfinance.com/legal/terms-of-use"
                >
                  Terms of Use
                </Link>{' '}
                and{' '}
                <Link
                  style={{
                    textDecoration: 'underline',
                    color: '#2171A6',
                  }}
                  isExternal
                  color="teal.500"
                  href="https://www.republicfinance.com/legal/privacy-policy"
                >
                  {' '}
                  Privacy Policy
                </Link>
              </Text>
            </ConsentBox>
            <ConsentBox
              consentTitle="E-Delivery Consent"
              onChange={this.props.onEDeliveryConsent}
              checkBoxLabel="I consent (optional)"
            >
              {' '}
              Check this box to acknowledge your consent for Republic Finance to
              provide your disclosure regarding payment transfer attempts
              required by using electronic delivery via email. You are not
              required to agree to electronic delivery of these federal payment
              transfer disclosures (“Payment Disclosures”). You may revoke
              E-Delivery Consent, and if you revoke E-Delivery Consent, then we
              will not provide Payment Disclosures electronically via email, and
              you may no longer be eligible to set up recurring payments with
              Republic Finance. We will not deliver Payment Disclosures
              electronically via email if we receive notification that you are
              unable to receive Payment Disclosures through that delivery method
              at the address used.
            </ConsentBox>

            {this.props.mobile && (
              <ConsentBox
                consentTitle="Permission to contact you"
                onChange={this.props.onTCPAConsent}
                checkBoxLabel="I consent (optional)"
              >
                {' '}
                <strong>
                  By providing my telephone number(s) in connection with this
                  request for pre-qualification and checking this box, I consent
                  to receive calls, text messages, artificial or pre-recorded
                  voice messages, and voicemail transmissions, including calls
                  made by an automated telephone dialing system or an automated
                  system for the selection or dialing of telephone numbers or
                  the playing of a recorded message when a connection is
                  completed to a number called, by or on behalf of Republic
                  Finance, regarding its products and services, including
                  telephonic sales calls and/or marketing communications. I
                  authorize these telemarketing calls and texts even if I have
                  previously included my telephone number(s) on any Do-Not-Call
                  registry or list. I understand I am not required to provide
                  this consent as a condition of purchasing any products or
                  service from Republic Finance. I certify that I have authority
                  to provide this consent because I am the regular user of the
                  telephone number(s) as the subscriber or a non-subscriber
                  customary user who has authority to consent to these
                  communications. I also agree to notify Republic Finance if my
                  telephone number(s) change. I have read, understand, and agree
                  to Republic Finance’s{' '}
                  <Link
                    style={{
                      textDecoration: 'underline',
                      color: '#2171A6',
                    }}
                    isExternal
                    color="teal.500"
                    href="https://www.republicfinance.com/legal/text-message-policy"
                  >
                    Text Message (SMS) Terms of Use
                  </Link>
                  .{' '}
                </strong>
              </ConsentBox>
            )}

            <Button
              mb={5}
              mt={10}
              w="100%"
              onClick={() => {
                this.setState({ isLoading: true })
                this.props.handleRegister()
              }}
              isDisabled={this.props.esignDisclosure === false}
              isLoading={this.state.isLoading}
            >
              Finish Enrolling
            </Button>
          </Card>
        </Center>
      </Box >
    )
  }
}

export default consents
